<template>
  <v-container>
    <h3>デジタル出力データ登録設定</h3>

    <div class="mt-8 mb-5">

      <v-row>
        <v-col :cols="$vuetify.display.mobile ? 12 : 4" class="d-flex align-center">
          <v-label>チャンネル選択</v-label>
        </v-col>
        <v-col :cols="$vuetify.display.mobile ? 12 : 8">
          <v-select density="compact" hide-details="true"
            v-model:model-value="channelKey" :items="channels"></v-select>
        </v-col>
      </v-row>

      <v-divider class="my-7"></v-divider>

      <v-row v-if="channelKey !== ''">
        <v-col :cols="$vuetify.display.mobile ? 12 : 4" class="d-flex align-center">
          <v-label>ステータス</v-label>
        </v-col>
        <v-col :cols="$vuetify.display.mobile ? 12 : 5">
          <v-chip :color="(isDataSaveEnabled) ? 'success' : ''" class="my-3">{{ isDataSaveEnabled ? 'データ登録中' : 'データ登録しない' }}</v-chip>
        </v-col>

        <v-col cols="12" class="my-2">
          <v-alert variant="tonal" type="success" v-model="isShowStartMessage" closable>
            データ登録を開始しました
          </v-alert>

          <v-alert variant="tonal" type="success" v-model="isShowDeleteMessage" closable>
            データ登録が停止されました
          </v-alert>
        </v-col>

        <v-col cols="12" class="text-end" v-if="isConfigurable && !isDataSaveEnabled">
          <v-btn :elevation="0" color="primary" :loading="isPostLoading" v-on:click="postDataSaveStart">
            データ登録を開始
          </v-btn>
        </v-col>

        <v-col cols="12" class="text-end" v-if="isConfigurable && isDataSaveEnabled">
          <v-btn variant="outlined" color="error" :loading="isDeleteLoading" v-on:click="isShowDialog = true;">
            データ登録を終了
          </v-btn>
        </v-col>
      </v-row>

    </div>

    <v-dialog max-width="400" v-model="isShowDialog">
      <v-card>
        <v-card-text>
          データ登録が停止されます。よろしいですか？
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn v-on:click="isShowDialog = false;">
            キャンセル
          </v-btn>
          <v-btn color="error" v-on:click="isShowDialog = false; deleteDataSaveSetting();">
            停止
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from 'vue';

import axios from 'axios';

import config from '@/config.js';

export default defineComponent({
  name: 'DigitalOutputDataSaveSetting',
  props: {
    moduleId: { type: String },
    isConfigurable: { type: Boolean }
  },

  setup(props) {

    const channelKey = ref('');
    const channels = ref([
      { title: '未選択', value: '' }
    ]);

    const isDataSaveEnabled = ref(false);

    const isPostLoading = ref(false);
    const isDeleteLoading = ref(false);

    const isShowStartMessage = ref(false);
    const isShowDeleteMessage = ref(false);

    const isShowDialog = ref(false);

    onMounted(() => {
      fetchChannelList();

      watch(channelKey, () => {
        isShowStartMessage.value = false;
        isShowDeleteMessage.value = false;

        if (channelKey.value === '') {
          return;
        }

        getDataSaveSetting();
      });
    });

    const fetchChannelList = () => {
      axios.get(
        config.API_URL +
        `/modules/${ props.moduleId }/channels`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        if ('do1' in response.data.channels) {
          channels.value.push({
            title: '（デジタル出力1）' + response.data.channels.do1.name,
            value: '1'
          });
        }

        if ('do2' in response.data.channels) {
          channels.value.push({
            title: '（デジタル出力2）' + response.data.channels.do2.name,
            value: '2'
          });
        }

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });
    };

    const getDataSaveSetting = () => {

      axios.get(
        config.API_URL +
        `/modules/${ props.moduleId }/channels/digital-output/${ channelKey.value }`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        isDataSaveEnabled.value = response.data.dataSaveEnabled

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const postDataSaveStart = async () => {

      isPostLoading.value = true;

      isShowDeleteMessage.value = false;

      axios.post(
        config.API_URL +
        `/modules/${ props.moduleId }/channels/digital-output/${ channelKey.value }`,
        {},
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((/* response */) => {

        isShowStartMessage.value = true;

        isDataSaveEnabled.value = true;

        isPostLoading.value = false;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const deleteDataSaveSetting = () => {

      isDeleteLoading.value = true;

      isShowStartMessage.value = false;

      axios.delete(
        config.API_URL +
        `/modules/${ props.moduleId }/channels/digital-output/${ channelKey.value }`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((/* response */) => {

        isDataSaveEnabled.value = false;

        isShowDeleteMessage.value = true;

        isDeleteLoading.value = false;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    return {
      channelKey,
      channels,

      isDataSaveEnabled,

      isPostLoading,
      isDeleteLoading,

      isShowStartMessage,
      isShowDeleteMessage,

      isShowDialog,

      postDataSaveStart,
      deleteDataSaveSetting
    }

  }
});
</script>
